export default __webpack_public_path__ + "img/stage4.97183c5b.png";